
import {
  HttpOptions,
  HttpError,
  HttpErrorCode
} from './types';
import {
  prepareOptions,
  validateOptions
} from './core';
import {
  createHttpError,
  createDetailedHttpError
} from '../utils';
import { requestInterceptor, responseInterceptor, errorInterceptor } from './interceptors';


const interceptors = {
  request: requestInterceptor,
  response: responseInterceptor,
  error: errorInterceptor
}

async function http(url: string, options: HttpOptions = {}): Promise<Response> {

  // 验证请求选项
  validateOptions(url, options);

  // 应用请求拦截器 - 用户可以在这里编写拦截器逻辑
  const { url: interceptedUrl, options: interceptedOptions } = await interceptors.request(url, options);

  // 使用统一的参数准备方法
  const { finalUrl, finalOptions } = prepareOptions(interceptedUrl, interceptedOptions);

  // 创建 AbortController 用于超时控制
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), finalOptions.timeout);

  try {
    const response = await fetch(finalUrl, {
      method: finalOptions.method,
      headers: finalOptions.headers,
      body: finalOptions.body,
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    // 检查 HTTP 状态码
    if (!response.ok) {
      const error = createHttpError(
        `HTTP Error: ${response.status} ${response.statusText}`,
        response.status,
        response.statusText,
      );

      // 应用错误拦截器
      const errorResult = await interceptors.error(error);
      throw errorResult;
    }

    // 应用响应拦截器
    return await interceptors.response(response);

  } catch (fetchError) {
    clearTimeout(timeoutId);

    let error: HttpError;
    if (fetchError.name === 'AbortError') {
      error = createDetailedHttpError(HttpErrorCode.TIMEOUT_ERROR);
    } else if (fetchError instanceof TypeError && fetchError.message.includes('fetch')) {
      error = createDetailedHttpError(HttpErrorCode.NO_CONNECTION);
    } else if (fetchError instanceof Error) {
      error = createHttpError(fetchError.message);
    } else {
      error = createDetailedHttpError(HttpErrorCode.TRANSACTION_ERROR);
    }
    // 应用错误拦截器
    const errorResult = await interceptors.error(error);
    throw errorResult;
  }
}

export type {
  HttpError,
}

export {
  createHttpError
}

export default http;


